export enum FieldType {
  Text = 'text',
  TextArea = 'textarea',
  Select = 'select',
  Checkbox = 'checkbox',
  Radio = 'radio',
  File = 'file',
  Paragraph = 'paragraph',
}
